import { render, staticRenderFns } from "./addUpdateEntityLocation.vue?vue&type=template&id=50bf3520&"
import script from "./addUpdateEntityLocation.vue?vue&type=script&lang=ts&"
export * from "./addUpdateEntityLocation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports